<template>
  <div class="global-right-section">
    <div class="calendar-header">
      <i class="iconfont icon-jiantou_liebiaoxiangzuo_o" @click="changeMoth(-1)"></i>
      <span>{{month}}</span>
      <i class="iconfont icon-jiantou_liebiaoxiangyou_o" @click="changeMoth(1)"></i>
    </div>
    <div class="data-overview">
      <p class="all-count">
        <span class="name">出勤人数</span>
        <span class="count">{{info.signNum || 0}}</span>
      </p>
      <div class="data-overview-model">
        <p>
          <span>班组签到：</span>
          <span>{{info.offSignNum || 0}}人</span>
        </p>
        <p>
          <span>实名签到：</span>
          <span>{{info.onSignNum || 0}}人</span>
        </p>
      </div>
    </div>
    <div class="calendar-body">
      <div class="item" v-for="(item, ind) in list" :key="'c' + ind">
        <div v-if="item.day" class="item-ctt item-click" :class="{ isSelect: ind === currentInd }" @click="changeDay(ind)">
          <p class="date"><span>{{item.day.split('-')[2]}}</span></p>
          <p class="num">{{item.signNum || 0}}</p>
        </div>
        <div v-else class="item-ctt">
          <p class="date"></p>
          <p class="num"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlanList',
  data () {
    return {
      month: this.$dayjs().format('YYYY-MM'),
      currentInd: -1,
      list: [],
      info: {}
    }
  },
  watch: {
    projectId () {
      this.loadData()
    }
  },
  computed: {
    projectId () {
      return this.$store.state.projectId || ''
    }
  },
  created () {
    const params = this.$route.query || {}
    if (params.month) {
      this.month = params.month
    }
    this.loadData(params.day)
  },
  destroyed () {
    // this.$event.$off('getMapData')
  },
  methods: {
    loadData (day) {
      this.$axios.get(this.$apis.overview.selectYhAttendanceCountByWeb, {
        yearMonth: this.month,
        projectId: this.projectId
      }).then(res => {
        this.info = res
        this.currentInd = -1
        this.formatList(res.list || [])
        if (day) {
          const ind = this.list.findIndex(item => item.day === this.month + '-' + day)
          ind >= 0 && this.changeDay(ind)
        }
      })
    },
    formatList (arr) {
      this.list = arr
      let startLen = this.$dayjs(this.month).day() - 1
      startLen = startLen === -1 ? 6 : startLen
      const totalLen = this.list.length + startLen > 35 ? 42 : 35
      const aStart = new Array(startLen)
      const aEnd = new Array(totalLen - this.list.length - startLen)
      aStart.length && aStart.fill({})
      aEnd.length && aEnd.fill({})
      this.list = aStart.concat(this.list)
      this.list = this.list.concat(aEnd)
    },
    changeMoth (num) {
      this.month = this.$dayjs(this.month).add(num, 'month').format('YYYY-MM')
      this.$event.$emit('getMapCheckInList')
      this.loadData()
    },
    changeDay (ind) {
      if (this.currentInd !== ind) {
        this.currentInd = ind
        const info = this.list[ind]
        this.$event.$emit('getMapCheckInList', info)
      }
    }
  }
}
</script>

<style scoped lang='scss'>
  .global-right-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: var(--form-bg-color);
    padding: 10px 10px;
    .calendar-header {
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        padding: 0 20px;
      }
      .iconfont {
        cursor: pointer;
      }
    }
    .data-overview{
      width: 278px;
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 14px;
      margin: 10px 0 10px;
      .all-count{
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 70px;
        border: 1px solid var(--right-border-color3);
        color: var(--right-font-color);
        .name{
          position: relative;
          display: flex;
          justify-content: center;
          width: 100%;
          height: 24px;
          line-height: 24px;
          background: var(--right-bg-color2);
          font-family: PingFang SC;
          font-weight: 600;
          font-size: 14px;
          &::before{
            left: 0;
            position: absolute;
            content: url('~@/assets/img/personSevice/icon-bg.png');
          }
        }
        .count{
          display: flex;
          justify-content: center;
          align-items: center;
          height: 46px;
          font-family: DIN-BlackItalic;
          font-weight: 400;
          font-size: 30px;
        }
      }
      .data-overview-model{
        display: flex;
        margin-top: 10px;
        justify-content: space-between;
        margin-right: 10px;
        p{
          position: relative;
          margin-left: 25px;
          &::before{
            position: absolute;
            left: -25px;
            top: 2px;
          }
          &:nth-of-type(1){
            &::before{
              content: url('~@/assets/img/personSevice/icon-avatar.png');
            }
          }
          &:nth-of-type(2){
            &::before{
              content: url('~@/assets/img/personSevice/icon-realname.png');
            }
          }
        }
      }
    }
    .calendar-body {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      border-bottom: 1px solid var(--calendar-border-color);
      .item {
        flex-shrink: 0;
        width: 14.28%;
        .item-click {
          cursor: pointer;
        }
        .item-ctt {
          border: 1px solid var(--calendar-border-color);
          border-bottom-color: transparent;
          padding: 0 !important;
          p {
            padding: 0 5px;
            line-height: 18px;
            &.date {
              width: 100%;
              height: 18px;
              background: var(--calendar-bg-color);
              span {
                opacity: 0.5;
              }
            }
            &.num {
              display: flex;
              justify-content: right;
              align-items: flex-end;
              height: 36px;
            }
          }
          &.isSelect {
            .date {
              background: var(--calendar-bg-color-select1);
            }
            background: var(--calendar-bg-color-select2);
            border: 1px solid var(--calendar-border-color-select) !important;
          }
        }
        &:first-child, & + .item:not(:nth-child(7n)) {
          .item-ctt {
            border-right-width: 0;
          }
        }
      }
    }
  }
</style>
